// test1848
(1848 && 0);
